module.exports = __webpack_public_path__ + "static/media/54.68305729.jpg";